import React from 'react';
import { MessageSquareIcon, UsersIcon, MapIcon, PhoneIcon, BookIcon } from 'lucide-react';
import { FeatureCard } from './ui/FeatureCard';
import { Button } from './ui/Button';
export function Features() {
  const features = [{
    icon: <MessageSquareIcon className="h-6 w-6" data-id="element-13" />,
    title: 'MimiBot AI Companion',
    description: "24/7 empathetic support with Mero's personality, understanding African family pressure and economic stress.",
    color: 'emerald'
  }, {
    icon: <UsersIcon className="h-6 w-6" data-id="element-14" />,
    title: 'Tribes (Community Support)',
    description: 'Anonymous peer support communities specific to your location and challenges, with trained moderators.',
    color: 'amber'
  }, {
    icon: <MapIcon className="h-6 w-6" data-id="element-15" />,
    title: 'Growth Paths',
    description: '30-day journeys combining CBT techniques with Ubuntu principles for anxiety, addiction, and relationship healing.',
    color: 'teal'
  }, {
    icon: <PhoneIcon className="h-6 w-6" data-id="element-16" />,
    title: 'Therapist Connect',
    description: 'Affordable access to culturally competent African therapists via text, voice, or video.',
    color: 'purple'
  }, {
    icon: <BookIcon className="h-6 w-6" data-id="element-17" />,
    title: 'Private Journal',
    description: 'End-to-end encrypted personal reflection space with CBT-informed thought tracking and pattern recognition.',
    color: 'emerald'
  }];
  return <section id="features" className="py-16" data-id="element-18">
      <div className="container mx-auto px-4" data-id="element-19">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-21">
            Healing rooted in African culture
          </h2>
          <p className="text-lg text-gray-700" data-id="element-22">
            MimiApp blends evidence-based therapy with cultural understanding,
            creating a mental wellness experience that truly speaks to young
            Africans.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-23">
          {features.map((feature, index) => <FeatureCard key={index} icon={feature.icon} title={feature.title} description={feature.description} color={feature.color as any} data-id="element-24" />)}
        </div>
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-xl overflow-hidden shadow-lg" data-id="element-25">
          <div className="md:flex" data-id="element-26">
            <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center" data-id="element-27">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-28">
                "Ubuntu: I am because we are"
              </h3>
              <p className="text-white/90 mb-6" data-id="element-29">
                MimiApp is built on the foundation of African wisdom that
                healing happens in community. Our approach combines traditional
                healing wisdom with modern psychological techniques.
              </p>
              <div data-id="element-30">
                <Button variant="secondary" data-id="element-31">Join Our Community</Button>
              </div>
            </div>
            <div className="md:w-1/2 relative" data-id="element-32">
              <img src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Group of young Africans in community support" className="w-full h-full object-cover" data-id="element-33" />
              <div className="absolute inset-0 bg-black/10" data-id="element-34"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}